import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './CookieConsent.module.scss';

const GA_MEASUREMENT_ID = 'G-MQKEZHPPJD';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === null) {
      setIsVisible(true);
    } else if (consent === 'true') {
      loadGA();
    }
  }, []);

  const loadGA = () => {
    if (window.gtag) return; // Already loaded

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);
    window.gtag = gtag; // expose to window for checking
  };

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
    loadGA();
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p>
          Utilizamos cookies propias y de terceros para obtener datos estadísticos de la
          navegación de nuestros usuarios y mejorar nuestros servicios. Puede aceptar o rechazar su uso
          clicando en los botones correspondientes. Puede cambiar la configuración u obtener
          más información <Link to="/cookies">aquí</Link>.
        </p>
        <div className={styles.buttons}>
          <button onClick={handleReject} className={styles.rejectBtn}>
            Rechazar
          </button>
          <button onClick={handleAccept} className={styles.acceptBtn}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};
